import axios from "axios";

export const FetchMatchDetails = async (matchId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_FEED_BASE_URL}/feeds/${process.env.REACT_APP_LEAGUE_NAME}/match-details/${matchId}?token=${process.env.REACT_APP_FEED_TOKEN}`
  );

  return response.data;
};
